class $d14fddc5e7b6d224$export$efa9a398d6368992 {
    constructor(){
        this.loggerVisualizer = document.getElementById("logger-visualizer");
    }
    log(message) {
        if (this.loggerVisualizer) this.loggerVisualizer.textContent += `${this.time()} ${message}\n`;
    }
    time() {
        const date = new Date();
        return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    }
    clear() {
        if (this.loggerVisualizer) this.loggerVisualizer.textContent = "";
    }
}


class $cdc0207dcefb02b1$export$2e2bcd8739ae039 {
    constructor(animationSteps){
        this.animationSteps = animationSteps;
        this.isCancelled = false;
        this.isPaused = false;
    }
    async swapAnimation(id1, id2) {
        return new Promise((resolve)=>{
            const element1 = document.getElementById(`element-${id1}`);
            const element2 = document.getElementById(`element-${id2}`);
            if (!element1 || !element2) {
                resolve();
                return;
            }
            element1.classList.add("swapping");
            element2.classList.add("swapping");
            const transform1 = element1.style.transform;
            const transform2 = element2.style.transform;
            element1.style.transform = transform2;
            element2.style.transform = transform1;
            setTimeout(()=>{
                if (this.isCancelled) {
                    resolve();
                    return;
                }
                element1.classList.remove("swapping");
                element2.classList.remove("swapping");
                resolve();
            }, 1600);
        });
    }
    async compareAnimation(id1, id2) {
        return new Promise((resolve)=>{
            const element1 = document.getElementById(`element-${id1}`);
            const element2 = document.getElementById(`element-${id2}`);
            if (!element1 || !element2) {
                resolve();
                return;
            }
            element1.classList.add("comparing");
            element2.classList.add("comparing");
            setTimeout(()=>{
                if (this.isCancelled) {
                    resolve();
                    return;
                }
                element1.classList.remove("comparing");
                element2.classList.remove("comparing");
                resolve();
            }, 1100);
        });
    }
    async delay(ms) {
        return new Promise((resolve)=>{
            setTimeout(()=>{
                if (this.isCancelled) {
                    resolve();
                    return;
                }
                resolve();
            }, ms);
        });
    }
    async runAnimations() {
        const logger = new (0, $d14fddc5e7b6d224$export$efa9a398d6368992)();
        logger.clear();
        for(let i = 0; i < this.animationSteps.length; i++){
            while(this.isPaused)await new Promise((resolve)=>{
                setTimeout(()=>{
                    resolve();
                    return;
                }, 300);
            });
            if (this.isCancelled) return;
            await this.delay(300);
            if (this.isCancelled) return;
            if (this.animationSteps[i].type == "compare") {
                logger.log(`Comparing ${this.animationSteps[i].id1} - ${this.animationSteps[i].id2}`);
                await this.compareAnimation(this.animationSteps[i].id1, this.animationSteps[i].id2);
            } else if (this.animationSteps[i].type == "swap") {
                logger.log(`Swapping ${this.animationSteps[i].id1} - ${this.animationSteps[i].id2}`);
                await this.swapAnimation(this.animationSteps[i].id1, this.animationSteps[i].id2);
            }
            if (this.isCancelled) return;
        }
    }
    setCancel() {
        this.isCancelled = true;
    }
    setPause() {
        this.isPaused = !this.isPaused;
    }
}


class $ff39133b61ad4808$export$c9a270af490f45a6 {
    constructor(swapped, compared, id, index){
        this.heightOffset = 3;
        this.leftOffset = 5;
        this.compared = compared;
        this.swapped = swapped;
        this.id = id;
        this.height = id ? id * this.heightOffset : this.heightOffset;
        this.left = index && index * this.leftOffset;
    }
}


var $de7c16c05f2550c7$export$2e2bcd8739ae039 = `
function bubbleSort(array: number[]) {
    const steps: Step[] = [];
    let swapped;
    for (let i = 0; i < array.length; i++) {
      for (let j = 0; j < array.length - 1; j++) {
        if (j == 0) {
          swapped = false;
        }
        if (array[j] > array[j + 1]) {
          array[j] = array[j] ^ array[j + 1];
          array[j + 1] = array[j] ^ array[j + 1];
          array[j] = array[j] ^ array[j + 1];
          swapped = true;
        }
      }
      if (swapped == false) {
        break;
      }
    }
  }
`;


var $8aad4b310f56796d$export$2e2bcd8739ae039 = `
function insertionSort(arr: number[]): Step[] {
  for (let i = 1; i < arr.length; i++) {
    let k = i;
    while (k > 0) {
      if (arr[k] < arr[k - 1]) {
        const temp = arr[k];
        arr[k] = arr[k - 1];
        arr[k - 1] = temp;
        k--;
      } else {
        break;
      }
    }
  }
}
`;


var $ad770f2a15d300f4$export$2e2bcd8739ae039 = `
function selectionSort(arr: number[]): Step[] {
  const steps: Step[] = [];
  for (let i = 0; i < arr.length - 1; i++) {
    let minIndex = i;
    for (let j = i + 1; j < arr.length; j++) {
      if (arr[j] < arr[minIndex]) {
        minIndex = j;
      }
    }
    if (minIndex !== i) {
      [arr[i], arr[minIndex]] = [arr[minIndex], arr[i]];
    }
  }
  return steps;
}
`;


function $50cd95281f7b46b1$export$2e2bcd8739ae039(str) {
    switch(str){
        case "Bubble Sort":
            return 0, $de7c16c05f2550c7$export$2e2bcd8739ae039;
        case "Insertion Sort":
            return 0, $8aad4b310f56796d$export$2e2bcd8739ae039;
        case "Selection Sort":
            return 0, $ad770f2a15d300f4$export$2e2bcd8739ae039;
    }
    return "No Sort";
}


class $7b3419e07b3ce3e5$export$a849fb01ab69b847 {
    initialize(array, sortType) {
        this.ArrayInititalize(array);
        this.ExplanationInitialize(sortType);
    }
    ArrayInititalize(array) {
        const arrayVisualizer = document.getElementById("array-container");
        const items = array.map((num, index)=>new (0, $ff39133b61ad4808$export$c9a270af490f45a6)(false, false, num, index + 1));
        const initialFrame = items.map((item)=>`<span class="array-element ${item.compared && "comparing"} ${item.swapped && "swapping"} " id="element-${item.id}"
      style="transform:translateX(${item.left ? item.left : 0}rem); height:${item.height ? item.height : 0}rem;">${item.id}</span>`).join("");
        if (initialFrame) arrayVisualizer?.insertAdjacentHTML("afterbegin", initialFrame);
    }
    ExplanationInitialize(sortType) {
        const explanation = (0, $50cd95281f7b46b1$export$2e2bcd8739ae039)(sortType);
        const explanationVisualizer = document.getElementById("explanation-visualizer");
        if (explanationVisualizer) explanationVisualizer.textContent = explanation;
    }
    reset() {
        const arrayVisualizer = document.getElementById("array-container");
        if (arrayVisualizer) arrayVisualizer.innerHTML = "";
    }
}


class $f757ab57ec69e182$export$f3470bc410429a68 {
    cancelAll() {
        while(this.animators.length > 0)this.animators.pop()?.setCancel();
    }
    pauseAll() {
        this.animators.forEach((animator)=>animator.setPause());
    }
    run(animator) {
        this.animators.push(animator);
        animator.runAnimations();
    }
    constructor(){
        this.animators = [];
    }
}


class $3724a61dbc2d9892$export$c7c44baae9d9f25f {
    constructor(options){
        this.options = options;
        this.playButton = document.getElementById("play-button");
        this.pauseButton = document.getElementById("pause-button");
        this.arraySelect = document.getElementById("array-type");
        this.sortSelect = document.getElementById("sort-type");
        this.bindEvents();
    }
    bindEvents() {
        if (this.playButton) this.playButton.onclick = ()=>this.handlePlay();
        if (this.pauseButton) this.pauseButton.onclick = ()=>this.options.onPause();
    }
    handlePlay() {
        if (!this.arraySelect || !this.sortSelect) return;
        const array = JSON.parse(this.arraySelect.value);
        const sortType = this.sortSelect.value;
        this.options.onPlay(array, sortType);
    }
}


class $00256a12267e990c$export$2e2bcd8739ae039 {
    constructor(type, id1, id2){
        this.type = type;
        this.id1 = id1;
        this.id2 = id2;
    }
}


function $270c90904c80dfca$export$2e2bcd8739ae039(array) {
    const steps = [];
    let swapped;
    for(let i = 0; i < array.length; i++){
        for(let j = 0; j < array.length - 1; j++){
            if (j == 0) swapped = false;
            steps.push(new (0, $00256a12267e990c$export$2e2bcd8739ae039)("compare", array[j], array[j + 1]));
            if (array[j] > array[j + 1]) {
                steps.push(new (0, $00256a12267e990c$export$2e2bcd8739ae039)("swap", array[j], array[j + 1]));
                array[j] = array[j] ^ array[j + 1];
                array[j + 1] = array[j] ^ array[j + 1];
                array[j] = array[j] ^ array[j + 1];
                swapped = true;
            }
        }
        if (swapped == false) break;
    }
    return steps;
}



function $27beaaadd21271a6$export$2e2bcd8739ae039(arr) {
    const steps = [];
    for(let i = 1; i < arr.length; i++){
        let k = i;
        while(k > 0){
            steps.push(new (0, $00256a12267e990c$export$2e2bcd8739ae039)("compare", arr[k - 1], arr[k]));
            if (arr[k] < arr[k - 1]) {
                steps.push(new (0, $00256a12267e990c$export$2e2bcd8739ae039)("swap", arr[k - 1], arr[k]));
                const temp = arr[k];
                arr[k] = arr[k - 1];
                arr[k - 1] = temp;
                k--;
            } else break;
        }
    }
    return steps;
}



function $a21114bf5387653d$export$b620ba1e5e879738(arr) {
    const steps = [];
    for(let i = 0; i < arr.length - 1; i++){
        let minIndex = i;
        for(let j = i + 1; j < arr.length; j++){
            steps.push(new (0, $00256a12267e990c$export$2e2bcd8739ae039)("compare", arr[minIndex], arr[j]));
            if (arr[j] < arr[minIndex]) minIndex = j;
        }
        if (minIndex !== i) {
            steps.push(new (0, $00256a12267e990c$export$2e2bcd8739ae039)("swap", arr[i], arr[minIndex]));
            [arr[i], arr[minIndex]] = [
                arr[minIndex],
                arr[i]
            ];
        }
    }
    return steps;
}


class $2cf3e51ae99822a5$export$980af03f4298a896 {
    static create(sortType, array) {
        switch(sortType){
            case "Bubble Sort":
                return (0, $270c90904c80dfca$export$2e2bcd8739ae039)(array);
            case "Insertion Sort":
                return (0, $27beaaadd21271a6$export$2e2bcd8739ae039)(array);
            case "Selection Sort":
                return (0, $a21114bf5387653d$export$b620ba1e5e879738)(array);
            default:
                throw new Error(`Unknown sort type: ${sortType}`);
        }
    }
}


const $b4e14b6b8da86996$var$frameInitializer = new (0, $7b3419e07b3ce3e5$export$a849fb01ab69b847)();
const $b4e14b6b8da86996$var$animatorManager = new (0, $f757ab57ec69e182$export$f3470bc410429a68)();
new (0, $3724a61dbc2d9892$export$c7c44baae9d9f25f)({
    onPlay: (array, sortType)=>{
        $b4e14b6b8da86996$var$frameInitializer.reset();
        $b4e14b6b8da86996$var$frameInitializer.initialize(array, sortType);
        $b4e14b6b8da86996$var$animatorManager.cancelAll();
        const steps = (0, $2cf3e51ae99822a5$export$980af03f4298a896).create(sortType, array);
        const animator = new (0, $cdc0207dcefb02b1$export$2e2bcd8739ae039)(steps);
        $b4e14b6b8da86996$var$animatorManager.run(animator);
    },
    onPause: ()=>{
        $b4e14b6b8da86996$var$animatorManager.pauseAll();
    }
});


//# sourceMappingURL=path0.4a96708b.js.map
